{
	"main": {
		"title": "Štartna lista motorni",
		"nezakljuceni": "NEZAKLJUČENI LETI",
		"zakljuceni": "ZAKLJUČENI LETI"
	},
	"table": {
		"reg": "REG.",
		"datum": "DATUM",
		"vzlet": "VZLET",
		"pilot": "PILOT",
		"naloga": "NALOGA",
		"pristanek": "PRISTANEK",
		"titleU": "Izpis ultralight letov"
	},
	"labels": {
		"datumOd": "Datum OD :",
		"datumDo": "Datum DO :",
		"pilotJ": "Izberi pilota jadralnega letala:",
		"instruktor": "Izberi inštruktorja jadralnega letala:",
		"registracijaJ": "Izberi reg. jadralnega letala :",
		"namenJ": "Izberi namen :",
		"nalogaJ": "Izberi nalogo jadralnega leta:",
		"pilotM": "Izberi pilota vlečnega letala:",
		"registracijaM": "Izberi reg. letala za vleko :",
		"vzlet": "Izberi vzlet :",
		"pristanek": "Izberi pristanek :",
		"poletanje": "Poletanje :",
		"odklop": "Odklop :",
		"nezakljucen": "Nezaključen let?",
		"pristanekJ": "Pristanek jadralnega letala:",
		"pristanekM": "Pristanek vlečnega letala:",
		"opomba": "Opomba",
		"niMozno": "Ta zapis ni možno urejati tukaj. Uredite ga lahko pri jadralnem letu!"
	},
	"modal": {
		"registracija": "registracija",
		"pilot": "pilot",
		"vlecno": "vlečno letalo:",
		"instruktor": "inštruktor: ",
		"namen": "namen:",
		"naloga": "naloga: ",
		"vzlet": "kraj vzleta: ",
		"pristanek": "kraj pristanka: ",
		"casVzleta": "čas vzleta:",
		"casOdklopa": "čas odklopa:",
		"casPristanka": "čas pristanka:",
		"casLetenja": "čas letenja:",
		"stPristankov": "št pristankov:",
		"ifr": "ifr: ",
		"nocno": "nočno: ",
		"vizuelno": "vizuelno: ",
		"opomba": "opomba: ",
		"datumL": "datum letenja: ",
		"datumV": "datum vnosa: ",
		"stanjeStevca": "Stanje števca: "
	},
	"edit": {
		"titleJ": "PODATKI JADRALNEGA LETALA",
		"reg": "Izberi reg. letala :",
		"pilot": "Izberi pilota :",
		"instruktor": "Izberi inštruktorja :",
		"namen": "Izberi namen :",
		"naloga": "Izberi nalogo :",
		"titleM": "PODATKI VLEČNEGA LETALA",
		"pilotM": "pilot vlečnega letala:",
		"regM": "registracija vlečnega letala",
		"titleS": "SPLOŠNI PODATKI",
		"krajV": "Izberi vzlet :",
		"krajP": "Izberi pristanek :",
		"opomba": "Opomba:"
	},
	"modalNL": {
		"title": "Zaključi izbran zapis",
		"reg": "registracija:",
		"pilot": "pilot:",
		"reg": "reg. vleke:",
		"instruktor": "inštruktor",
		"namen": "namen: ",
		"naloga": "naloga: ",
		"casV": "čas vzleta:",
		"krajV": "kraj vzleta:",
		"krajP": "kraj pristanka:",
		"pristanekM": "Pristanek motornega letala:",
		"klubL": "Klub letala:",
		"klubP": "Klub pilota:",
		"casL": "čas letenja:",
		"opomba": "opomba: ",
		"datumL": "datum letenja: ",
		"datumV": "datum vnosa: ",
		"stanjeStevca": "Stanje števca: ",
		"v_zraku": "Čas v zraku: "
	},
	"buttons": {
		"zakljuciLet": "Zaključi let",
		"brisiIzbiro": "Pobriši izbiro",
		"urediPodatke": "Uredi podatke",
		"posodobiPodatke": "Posodobi podatke",
		"izbrisiZapis": "Izbriši zapis",
		"csv": "Izvoz v CSV ",
		"natisni": "Natisni ",
		"poslji": "Pošlji "
	},
	"data": {
		"title": "Podatki",
		"stPristankov": "Št. pristankov:",
		"stLetov": "Št. letov:",
		"casVZraku": "Trajanje:"
	},
	"obvestila": {
		"zapisPrihodnost": "Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!",
		"zapisCasPrihodnost": "Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!",
		"zapisCasNapaka": "Časi zapisov so nepravilni! Preveri čase še enkrat!",
		"napakaPristanka": "Čas pristanka ne more biti pred časom poleta!",
		"zapisPobrisan": "Zapis uspešno pobrisan",
		"napakaPrazenPristanek": "Napaka pri vnosu, čas pristanka ne more biti prazen",
		"posodobitevUspesna": "Posodobitev uspešna",
		"napakaPosodabljanja": "Napaka pri posodabljanju podatkov.",
		"napakaBranja": "Napaka pri branju podatkov.",
		"napakaIzbrisa": "Napaka pri izbrisu podatkov.",
		"vprasanjeIzbris": "Ali res želite pobrisati zapis?",
		"napakaVnosa": "Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!",
		"letZakljucen": "Let uspešno zaključen.",
		"letNiZakljucen": "Napaka pri zaključevanju leta."
	}
}